import BWAccordion from 'components/shared/BWAccordion/index';
import FormEditorQuill from 'components/shared/BWFormControl/FormEditorQuill';
import React from 'react';

const JobRequirementsEn = ({ disabled, title, id }) => {
  return (
    <BWAccordion title={title} id={id}>
      <FormEditorQuill field='requirements_en' disabled={disabled} />
    </BWAccordion>
  );
};

export default JobRequirementsEn;
